import { get } from 'lodash';

export const allFields = ['oldPassword', 'password', 'confirmPassword'];


export const initializeChangePasswordState = () => {
  return {
    oldPassword: { value: '', errors: [] },
    password: { value: '', errors: [] },
    confirmPassword: { value: '', errors: [] },
  }
};

export const validateField = ({ field, value, intl, state, regexPolicy }) => {
  const errors = [];

  if (field === 'oldPassword') {
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    }
  }

  if (field === 'confirmPassword') {
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    } else if (value !== state.password.value) {
      errors.push(intl.getI18nMessage("label.user.profile.password.match.error"));
    }
  }

  if (field === 'password') {
    const regex = get(regexPolicy, 'REGEX.value', '');
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    } else if (!(new RegExp(regex).test(value))) {
      errors.push(intl.getI18nMessage("label.user.profile.password.format.error"));
    } else if (state.confirmPassword.value && (value !== state.confirmPassword.value)) {
      errors.push(intl.getI18nMessage("label.user.profile.password.match.error"));
      state.confirmPassword.errors.push(intl.getI18nMessage("label.user.profile.password.match.error"));
    } else {
      state.confirmPassword.errors = [];
    }
  }

  return errors;
}

export const validateFormInputs = ({ state, intl, regexPolicy }) => {
  let isFormValid = true;
  const validatedState = allFields.map(field => {
    const fieldErrors = validateField({
      field, value: state[field].value, intl, state, regexPolicy,
    });
    if (fieldErrors.length > 0) {
      isFormValid = false;
    }
    return { field, value: state[field].value, errors: fieldErrors }
  })
  return { validatedState, isFormValid };
}